<template>
  <!--#region order table  -->
  <orders-table
    @paginate="getFilteredOrders"
    @orderReProcessed="orderReProcessed"
    :paginationInfo="paginationInfo"
    :isLoading="isLoading"
    :orders="orders"
    :templates="tableCols"
  ></orders-table>
  <!--#endregion -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PaginatedApiModel } from '../models/api/response';
import OrdersTable from './orders-table.vue';
import { OrderClientModel } from '../models/client';
import { orderService } from '../services';
import { ElNotification } from 'element-plus';

export default defineComponent({
  name: 'xqc-reprint-table',
  components: {
    OrdersTable,
  },
  emits: ['orderReProcessed'],
  data: function () {
    return {
      isLoading: false,
      tableCols: [
        { label: 'XQC', props: 'xqc', width: '150' },
        { label: 'Reprint', props: 'reprint', width: '150' },
      ],
      updatingOrders: {},
      orders: [] as OrderClientModel[],
      paginationInfo: null as PaginatedApiModel<OrderClientModel> | null,
      total: 10,
    };
  },
  async created() {
    await this.getFilteredOrders();
  },
  methods: {
    orderReProcessed() {
      this.$emit('orderReProcessed');
    },
    async getOrders() {
      await this.getFilteredOrders();
    },
    async getFilteredOrders(page = 1) {
      const filter = {
        page,
        total: this.total,
      };
      this.isLoading = true;
      try {
        const response = await orderService.getReprintXqcOrder(filter);
        this.orders = response.data;
        if (!this.orders.length && page != 1) {
          await this.getFilteredOrders(page - 1);
          return;
        }
        this.paginationInfo = response;
      } catch (e) {
        // 401 error will be handled by response interceptor
        if (e.response.status !== 401) {
          ElNotification({
            title: 'Error',
            type: 'error',
            message: 'Failed to load requested data. Please try again later.',
            position: 'bottom-right',
          });
        }
      }
      this.isLoading = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.tableContainer ::v-deep(tr) {
  cursor: pointer;
  text-transform: capitalize;
}

.action-icons:hover {
  margin-top: -1px;
}
</style>
